import React from 'react';

type Props = {
  fillColor?: string;
  width?: string;
  height?: string;
};

const CautionIcon = (props: Props) => {
  return (
    <svg
      width={props?.width || '22'}
      height={props?.height || '22'}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.08" cx="11" cy="11" r="11" fill={props?.fillColor || '#148627'} />
      <path
        d="M12.1907 13.564V16H9.63571V13.564H12.1907ZM12.2957 5.878L11.6727 12.626H10.1957L9.53071 5.878H12.2957Z"
        fill={props?.fillColor || '#148627'}
      />
    </svg>
  );
};

export default CautionIcon;
